<template>
    <div>
        <headerNav title="意见及反馈"/>
        <div>
             <van-cell-group>
             <van-field
                v-model="model.message"
                rows="8"
                autosize
                label="意见及反馈"
                type="textarea"
                maxlength="100"
                placeholder="请填写意见及反馈"
                show-word-limit
            />

         </van-cell-group>
            <div class="btns">
                <van-button @click="addideal" :disabled="isdisabled" :style="{'background-color':$abctheme.basecolor,'color':'#fff'}">提交意见及反馈</van-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            model:{},
            isdisabled:false
        }
    },
    methods:
    {
        addideal()
        {
            this.isdisabled=true;
            if(!this.model.message)
            {
                this.isdisabled=false;
                this.$toast.fail("请填写意见及反馈");
                return;
            }
            this.ajax.post("/api/services/app/PhoneCom/CreateIdeal",this.model).then(x=>
            {
                this.$toast.success("创建成功");
                this.$router.back(-1);
            }).finally(x=>
            {
                this.isdisabled=false;
            })
            
        }
    }
}
</script>
<style lang="scss" scoped>
.btns{
    margin-top: 15px;
    text-align: center;
}
</style>